import {formateData, headers} from "./index";

export const getAllEmotionsList = (mediaCode, type, callBack)=> {
    let url = "/cm-sites-pms/weibo/getEmotions";
    fetch(url, {
        method: 'post',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData({mediaCode, type})
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getAllEmotionsList",error);
        callBack([]);
    })
};